import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';
import { ReducerActionRotaSP } from 'store/modules/types';

// TYPES
import { cleanEmpty } from 'utils/genericFunctions';
import { Types, AtualizarSiglaRequest } from './types';

// ACTIONS
import { atualizarSiglaSuccess, atualizarSiglaFailure } from './actions';

function* atualizarSigla(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: AtualizarSiglaRequest } = request;


	let body = { ...payload };

	body = cleanEmpty(body) as AtualizarSiglaRequest;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_SGU_API,
		`siglas/${payload.id}`,
		body,
	);

	if (response.status === 200) {
		yield put(atualizarSiglaSuccess(response));
	} else {
		yield put(atualizarSiglaFailure());
	}
}

export default all([takeLatest(Types.ATUALIZAR_SIGLA_REQUEST, atualizarSigla)]);
